import initialState from "./initialState";

const types = {
  reset: "reset",
  SET_DASHBOARDS: "SET_DASHBOARDS",
};

const mutations = {
  /**
   * Resets the state with initial state
   */
  [types.reset]: state => {
    Object.keys(initialState()).forEach(key => {
      state[key] = initialState()[key];
    });
  },
  /**
   * Sets the list of all the current dashboards
   */
  [types.SET_DASHBOARDS]: (state, data) => {
    state.consoles = data;
    state.consolesById = Object.keys(data);
  },
};

export default mutations;
export { types };
